module.exports = __webpack_public_path__ + "img/73.4cac3f58.jpg";